import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { Subscription, distinctUntilChanged, filter } from 'rxjs';

@Component({
  selector: 'irembogov-hide-field-wrapper',
  templateUrl: './hide-field-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class HideFieldWrapperComponent
  extends FieldWrapper
  implements OnInit, OnDestroy
{
  private fieldChangesSub: Subscription | undefined;

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  // Change to ngOnInit so RFA programmatic updates gets called
  ngOnInit(): void {
    this.updateClasses();

    this.fieldChangesSub = this.field.options?.fieldChanges
      ?.pipe(
        filter(
          e =>
            e.type === 'expressionChanges' &&
            e['property'] === 'props.hideField' &&
            e.field.key === this.field.key
        ),
        // Compare the actual boolean value
        distinctUntilChanged((prev, curr) => prev.value === curr.value)
      )
      .subscribe({
        next: () => {
          this.updateClasses();
          // FORCE Angular to update the view during asynchronous RFA data patching
          this.cd.detectChanges();
        },
      });
  }

  private updateClasses(): void {
    let classesArr: string[] = this.field.className
      ? this.field.className.split(' ')
      : [];

    // Clean out the old class first
    classesArr = classesArr.filter(x => x !== 'irembo-formly-hidden-field');
    // Add it back if hideField is true
    if (this.field.props?.['hideField']) {
      classesArr.push('irembo-formly-hidden-field');
    }

    this.field.className = classesArr.join(' ').trim();
  }

  ngOnDestroy(): void {
    this.fieldChangesSub?.unsubscribe();
  }
}
